<template>
  <section>
    <div class="container is-centered">
        <div class="has-text-centered">
          <h1 class="header is-size-1 has-text-weight-bold">Submit Fault Report</h1>
        </div>
        <div class="options">
              <a class="button is-primary is-large" @click="$router.push('/qr')">Click to scan QR</a>
              <a class="button is-primary is-large" @click="$router.push('/manual')">Click to enter code</a>
        </div>
    </div>
  </section>
</template>

<script>
import { QrcodeReader } from 'vue-qrcode-reader'

export default {
  name: 'home',
  components: {
    QrcodeReader
  },
  data () {
    return {
      code: null,
      manualInput: false
    }
  },
  methods: {
    enterCode () {
      this.manualInput = true
    }
  }
}
</script>
<style scoped lang="stylus">

.container
  h1
    margin-top: 2.5rem
  @media (min-width: 768px)
    width: 40%
.options
  position: relative
  top: 6rem
  text-align: center
  a, button
    width: 90%
    margin: 1rem

.fade-enter-active, .fade-leave-leave-to
  transition: all 0.8s

.fade-enter, .fade-leave-to
  opacity: 0

</style>
